import { Loader2 } from 'lucide-react';

/**
 * Spinner — a small, discreet rotating indicator. Rendered next to the "Festipod"
 * title while at least one data query is still waiting for its first result (see
 * the global `usePendingQueries` store). The rotation keyframe (`app-spin`) and the
 * `.app-spinner` class live in `src/index.css`, the style source of truth.
 */
export function Spinner({ size = 16, color = 'var(--app-accent)' }: { size?: number; color?: string }) {
  return (
    <Loader2
      className="app-spinner"
      size={size}
      color={color}
      aria-label="Chargement des données"
      role="status"
    />
  );
}
